import {
  CalendarMonth,
  Checklist,
  DataObject,
  Euro,
  Flaky,
  Home,
  Numbers,
  Percent,
  Person,
  SquareFoot,
  TextFields,
} from "@mui/icons-material";
import { SvgIconProps } from "@mui/material";
import { ParsingType } from "../../../interfaces/doc";

function ExtractionIcon({
  parsingType,
  props,
}: {
  parsingType: ParsingType;
  props?: SvgIconProps;
}) {
  switch (parsingType) {
    case ParsingType.Name:
      return <Person {...props} />;
    case ParsingType.Address:
      return <Home {...props} />;
    case ParsingType.String:
      return <TextFields {...props} />;
    case ParsingType.Float:
      return <Percent {...props} />;
    case ParsingType.Int:
      return <Numbers {...props} />;
    case ParsingType.Date:
      return <CalendarMonth {...props} />;
    case ParsingType.Measure:
      return <SquareFoot {...props} />;
    case ParsingType.Currency:
      return <Euro {...props} />;
    case ParsingType.Boolean:
      return <Flaky {...props} />;
    case ParsingType.Custom:
      return <DataObject {...props} />;
    case ParsingType.Enum:
      return <Checklist {...props} />;
    default:
      return <TextFields {...props} />;
  }
}

export default ExtractionIcon;
